<template>
  <b-card>
    <b-card-title>
      Previous Video calls
    </b-card-title>

    <section v-if="loading">
      <b-spinner variant="primary" label="Loading previous calls"></b-spinner>
    </section>

    <section v-else>
      <p v-if="prisoner_number">
        Visitor has had <b>{{numberOfVisitsWithPrisoner()}}</b>
        video call<span v-if="numberOfVisitsWithPrisoner() > 1">s</span> with resident <b>#{{prisoner_number}}</b>
        <span v-if="numberOfVisitsWithPrisonerTerminated() > 0">, <b class="text-danger">{{numberOfVisitsWithPrisonerTerminated()}}</b> of which have been terminated
          </span>
      </p>
      <section class="previous-visits-table" v-if="previousVisitsTableData && previousVisitsTableData.length > 0">
        <p><b>All Previous Video Calls</b></p>
        <b-table
          hover
          :fields="columns"
          :items="previousVisitsTableData"
          :current-page="currentPage"
          :per-page="perPage"
          :responsive="true"
        >
          <template #cell(actions)="data">
            <router-link v-bind:to="{ name: 'call-details', params: { id: data.item._id }}" class="btn btn-sm btn-primary">
              <span class="fas fa-search"></span> View
            </router-link>
          </template>
        </b-table>
      </section>
      <b-row v-if="previousVisitsTableData && previousVisitsTableData.length > 0">
        <b-col md="6" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
      <div v-if="!previousVisitsTableData || previousVisitsTableData.length === 0">
        <p>Visitor has no previous video calls</p>
      </div>
    </section>
  </b-card>
</template>

<script>
  import VisitorService from '@/services/VisitorService';
  import moment from 'moment';
  import {getVisitBookedForDate} from '@/util/helpers';
  import {logger} from '@/util/logger';

  export default {
    name: 'visitors-previous-visits',
    props: {
      visitor_user_id: {
        type: String,
        required: true,
      },
      prisoner_number: {
        type: String,
        required: false,
      },
    },
    watch: {
      visitor_user_id() {
        // Get new visitor info
        this.getPreviousVisits();
      },
      prisoner_number() {
        this.numberOfVisitsWithPrisoner();
        this.numberOfVisitsWithPrisonerTerminated();
      },
    },
    data() {
      return {
        loading: true,
        previousVisits: [],
        columns: [
          {
            key: 'date',
            name: 'Date',
          },
          {
            key: 'prisonerNumber',
            label: this.$options.filters.term('prison', true) + ' Number',
          },
          {
            key: 'actions',
            label: 'Actions',
          },
        ],
        previousVisitsTableData: [],
        currentPage: 1,
        perPage: 5,
        totalRows: 0,
      };
    },
    mounted() {
      this.getPreviousVisits();
    },
    methods: {
      getPreviousVisits() {
        this.loading = true;

        VisitorService.getPreviousVisits(this.visitor_user_id).then(res => {
          this.previousVisits = res.data;
          if(this.previousVisits && this.previousVisits.length > 0) {
            this.previousVisitsTableData = this.previousVisits.map((visit) => {
              return {
                _id: visit._id,
                date: moment(getVisitBookedForDate(visit).bookedForDate).format('DD/MM/YYYY'),
                prisonerNumber: visit.prisoner.prisoner_number,
                _rowVariant: visit.was_terminated ? 'danger' : '',
              };
            });
            this.totalRows = this.previousVisitsTableData.length;
          }
          this.loading = false;
        }).catch(err => {
          logger.error('Error getting users previous visit', err, {visitorUserId: this.visitor.user_id}, 'VisitorsPreviousVisits:getPreviousVisits');
          this.$toast.error('Error getting users previous visits. Please check your connection and refresh the page.', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      numberOfVisitsWithPrisoner() {
        let numberOfVisitsWithPrisoner = 0;
        if(this.previousVisits) {
          this.previousVisits.forEach((visit) => {
            if(this.prisoner_number.toLowerCase() === visit.prisoner.prisoner_number.toLowerCase()) {
              numberOfVisitsWithPrisoner += 1;
            }
          });
        }
        return numberOfVisitsWithPrisoner.toString();
      },
      numberOfVisitsWithPrisonerTerminated() {
        let numberOfVisitsWithPrisonerTerminated = 0;
        if(this.previousVisits) {
          this.previousVisits.forEach((visit) => {
            if(this.prisoner_number.toLowerCase() === visit.prisoner.prisoner_number.toLowerCase() && visit.was_terminated) {
              numberOfVisitsWithPrisonerTerminated += 1;
            }
          });
        }
        return numberOfVisitsWithPrisonerTerminated.toString();
      },
    },
  };
</script>
